/**
 * For empty selections, the start and end will be the same
 */

/**
 * type guard to detect if the initial context is for range selection
 * based on selection prop availability
 */
export function isInitialContextSelectionRange(value) {
  return 'selection' in value && typeof value.selection === 'string';
}

/**
 * `EditorPluginAIConfigItem`s are used by EditorPluginAI
 * to provide AI experiences.
 *
 * **This type is not inteded to be used directly by consumers**
 * when building config items. For creating objects which conform
 * to this type:
 * @see {@link createEditorPluginAIConfigItem}
 *
 */

/**
 * This creates a new EditorPluginAI config item (`EditorPluginAIConfigItem`)
 * for use when setting up an editorPluginAI.
 *
 * @example
 * ```tsx
 * const configItem = createEditorPluginAIConfigItem({...})
 * const editorPluginAI = new EditorPluginAI({
 *   configItems: [configItem],
 *   editorPluginAIProvider,
 * })
 * ```
 */
// Creating via a function like this helps with type inference
export function createEditorPluginAIConfigItemMarkdown(editorPluginAIConfigItem) {
  return editorPluginAIConfigItem;
}